import Constants from 'expo-constants'
import { log } from '../pwa'

export const checkForUpdates = async () => {
  log.info('Detected web platform, skipping update checks')
  return
}

const buildVersion = (): string => {
  const { version } = Constants.expoConfig

  return version
}

export const version = buildVersion()